if (typeof document !== 'undefined' && process.env.NODE_ENV !== 'test' && !document.head.querySelector("style[data-wp-hash='294e36b777']")) {
	const style = document.createElement("style");
	style.setAttribute("data-wp-hash", "294e36b777");
	style.appendChild(document.createTextNode(".boot-save-button{width:100%}"));
	document.head.appendChild(style);
}
